import { Outlet } from "react-router-dom"
import "./Appointment.scss"

import { useCookies } from "react-cookie"
import { PageBody } from "../../components/pageBody/PageBody"
import { type Cookie, type CookieTypes } from "../../cookies/cookies"

export function AppointmentPage(): JSX.Element {
  const [cookies] = useCookies<CookieTypes, Cookie>([])
  const { appParams } = cookies

  return (
    <PageBody allowLogout={true}>
      {appParams !== undefined && <div className="provider">Your hospital provides this service</div>}
      <Outlet />
    </PageBody>
  )
}
